module.exports = __webpack_public_path__ + "img/crtc.66adf372.jpg";